export function prefersReducedMotion() {
    if (typeof window == 'undefined') {
        return false;
    } else {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
}